<template>
  <activity-summary v-if="ready" @success="handleSuccess" />
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import axios from 'axios'
  import swal from 'sweetalert2'
  import { jiminnyHost } from '@/helpers/region'
  import { addBeforeUnload, removeBeforeUnload } from '@/lib/before-unload'
  import ActivitySummary from 'vue-components/activity-summary/components/activity-summary'

  const { mapMutations } = createNamespacedHelpers('activitySummary')

  export default {
    components: {
      ActivitySummary
    },
    props: [
      'id'
    ],
    data () {
      return {
        ready: false,
        logged: false
      }
    },
    created () {
      addBeforeUnload('ACTIVITY_SUMMARY_PROTECTION', 'Are you sure you want to leave without logging this activity?')
      this.retrieveActivity()
    },
    beforeDestroy () {
      removeBeforeUnload('ACTIVITY_SUMMARY_PROTECTION')
    },
    beforeRouteLeave (to, from, next) {
      if (this.logged) {
        next()
      } else {
        swal({
          text: 'Are you sure you want to leave without logging this activity?',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: true,
          confirmButtonText: 'Yes',
          confirmButtonColor: '#f0415a',
          cancelButtonText: 'No'
        }).then((result) => next(!!result.value))
      }
    },
    methods: {
      ...mapMutations([
        'setActivity'
      ]),
      async retrieveActivity () {
        try {
          const response = await axios.get(`${jiminnyHost()}/api/v1/activity/${this.id}`)
          this.setActivity(response.data)
          this.ready = true
        } catch (error) {
          console.error(error)
        }
      },
      handleSuccess () {
        this.logged = true
        this.$router.push('/')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// activity-summary.vue?3b15653a